import UserSvc from '@/services/UserSvc';
import RoleSvc from '@/services/RoleSvc';
import CompanySvc from '@/services/CompanySvc';
import AssetSvc from '@/services/AssetSvc';
import requestBuilder from '@/util/request.builder';

// ponytail: single-page fetch capped at 100, same ceiling the original 3 tabs already used
const RELATED_FETCH_PAGINATION = { current: 1, pageSize: 100 };

export const companyRelation = {
  title: 'Company',
  accessKey: 'master_company',
  entityIdKey: 'compId',
  entityNameKey: 'compName',
  extraField: {
    key: 'uscoAllAssets',
    label: 'Have Access To All Asset',
    columnLabel: 'Access To All Assets',
    default: '1',
    options: [{ value: '1', text: 'Yes' }, { value: '0', text: 'No' }],
  },
  async fetchAssigned(parentId, pagination) {
    const res = await UserSvc.getUserCompany({
      params: { ...requestBuilder.buildFilters(pagination, { uscoUserId: parentId }) },
    });
    return { items: res.data.data, totalSize: res.data.pagination.totalData };
  },
  async fetchRelatedAll() {
    const res = await CompanySvc.getCompanies({
      params: { ...requestBuilder.buildFilters(RELATED_FETCH_PAGINATION, {}) },
    });
    return res.data.data;
  },
  async searchRelated(term) {
    const res = await CompanySvc.getCompanyByName({ findField: 'compName', findValue: term });
    return res.data.data;
  },
  createAssigned(parentId, entityId, extra) {
    return UserSvc.addUserCompany({
      uscoCompId: entityId,
      uscoUserId: parentId,
      uscoAllAssets: extra.uscoAllAssets,
    });
  },
  deleteAssigned(row) {
    return UserSvc.deleteUserCompany(row.uscoId);
  },
  getAssignedEntityId(row) {
    return row.uscoCompId;
  },
};

export const roleRelation = {
  title: 'Role',
  accessKey: 'master_role',
  entityIdKey: 'roleId',
  entityNameKey: 'roleName',
  async fetchAssigned(parentId, pagination) {
    const res = await RoleSvc.getUserRoles({
      params: { ...requestBuilder.buildFilters(pagination, { usroUserId: parentId }) },
    });
    return { items: res.data.data, totalSize: res.data.pagination.totalData };
  },
  async fetchRelatedAll() {
    const res = await UserSvc.getRoles({
      params: { ...requestBuilder.buildFilters(RELATED_FETCH_PAGINATION, {}) },
    });
    return res.data.data;
  },
  async searchRelated(term) {
    const res = await UserSvc.getRoleByName({ findField: 'roleName', findValue: term });
    return res.data.data;
  },
  createAssigned(parentId, entityId) {
    return UserSvc.addUserRole({ usroRoleId: entityId, usroUserId: parentId });
  },
  deleteAssigned(row) {
    return UserSvc.deleteUserRole(row.usroId);
  },
  getAssignedEntityId(row) {
    return row.usroRole.roleId;
  },
  getAssignedEntityName(row) {
    return row.usroRole.roleName;
  },
};

export const assetRelation = {
  title: 'Asset',
  accessKey: 'master_asset',
  entityIdKey: 'massId',
  entityNameKey: 'massName',
  async fetchAssigned(parentId, pagination) {
    const res = await UserSvc.getUserAssets({
      params: { ...requestBuilder.buildFilters(pagination, { uassUserId: parentId }) },
    });
    return { items: res.data.data, totalSize: res.data.pagination.totalData };
  },
  async fetchRelatedAll() {
    const res = await AssetSvc.getAssets({
      params: { ...requestBuilder.buildFilters(RELATED_FETCH_PAGINATION, {}) },
    });
    return res.data.data;
  },
  async searchRelated(term) {
    const res = await AssetSvc.getAssetByName({ findField: 'massName', findValue: term });
    return res.data.data;
  },
  createAssigned(parentId, entityId) {
    return UserSvc.createUserAsset({ uassMassId: entityId, uassUserId: parentId });
  },
  deleteAssigned(row) {
    return UserSvc.deleteUserAsset(row.uassId);
  },
  getAssignedEntityId(row) {
    return row.uassMassId;
  },
};
